import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core'
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router'
import { Subject } from 'rxjs'
import { filter, takeUntil } from 'rxjs/operators'
import { TabConfig } from '../../../shared/components/tabs/tabs.component'
import { OnboardingService } from '../../services/onboarding.service'

@Component({
  selector: 'app-account-settings-tabs',
  templateUrl: './account-settings-tabs.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AccountSettingsTabsComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>()

  tabs: TabConfig[] = [
    { label: 'General', route: '' },
    { label: 'Retention Policy', route: 'retention' },
    { label: 'Identity Providers', route: 'identity-providers' },
    { label: 'Resource Defaults', route: 'resources' },
    { label: 'Tags', route: 'tags' },
    { label: 'API Keys', route: 'api-keys' },
  ]

  baseRoute: string
  landingPageRoute: string
  showBackToWelcome = false

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private onboardingService: OnboardingService
  ) {}

  ngOnInit() {
    // Get accountId from parent route params
    const accountId = this.route.parent?.snapshot.paramMap.get('accountId')
    this.baseRoute = `/${accountId}/account/settings`
    this.landingPageRoute = `/${accountId}/welcome`

    // Check if user came from welcome page
    this.showBackToWelcome = this.route.snapshot.queryParamMap.get('from') === 'welcome'

    // Track tab visits for onboarding
    this.trackCurrentTab()
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        takeUntil(this.destroy$)
      )
      .subscribe(() => {
        this.trackCurrentTab()
      })
  }

  ngOnDestroy() {
    this.destroy$.next()
    this.destroy$.complete()
  }

  navigateBackToWelcome() {
    this.router.navigateByUrl(this.landingPageRoute)
  }

  private trackCurrentTab() {
    // Strip query params for reliable URL matching
    const url = this.router.url.split('?')[0]
    if (url.includes('/account/settings/retention')) {
      this.onboardingService.markAccountSettingsTabVisited('retention')
    } else if (url.includes('/account/settings/identity-providers')) {
      this.onboardingService.markAccountSettingsTabVisited('identityProviders')
    } else if (url.includes('/account/settings/api-keys')) {
      this.onboardingService.markAccountSettingsTabVisited('apiKeys')
    } else if (url.endsWith('/account/settings') || url.endsWith('/account/settings/')) {
      this.onboardingService.markAccountSettingsTabVisited('general')
    }
  }
}
